import { render, staticRenderFns } from "./resultatDirect.vue?vue&type=template&id=4b8606c2&scoped=true"
import script from "./resultatDirect.vue?vue&type=script&lang=js"
export * from "./resultatDirect.vue?vue&type=script&lang=js"
import style0 from "./resultatDirect.vue?vue&type=style&index=0&id=4b8606c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8606c2",
  null
  
)

export default component.exports